import React, { useState, useEffect } from 'react'
import PendingCash from '../../../../../../../Restaurant/Caja/CajasManagement/components/PendingCash/PendingCash'
import { Modal, Button } from 'react-bootstrap'
import { X } from 'react-bootstrap-icons'
import { getLocalCajaManagementByLocalId } from '../../../../../../../../crud/management_api/locales_caja_management'

interface ModalPendingCashProps {
  show: boolean;
  onHide: () => void;
  cajas: any[]; // This is actually pending transactions from PendingTable, not cajas
  setCajas: (cajas: any[]) => void;
}

const ModalPendingCash: React.FC<ModalPendingCashProps> = ({ show, onHide, cajas, setCajas }) => {
  // Local state for actual cajas (workstations)
  const [actualCajas, setActualCajas] = useState<any[]>([]);

  // Initialize cajas when modal opens
  useEffect(() => {
    if (show) {
      refreshCajas();
    }
  }, [show]);

  const refreshCajas = async () => {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const localId = user ? Number(user.local_id) : 0;
    
    try {
      const response = await getLocalCajaManagementByLocalId(localId);
      setActualCajas(response.data);
    } catch (error) {
      console.error('Error fetching cajas: ', error);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="sm" centered>
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Efectivo por recibir</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onHide}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <PendingCash 
          cajas={actualCajas} 
          setCajas={setActualCajas} 
          refreshCajas={refreshCajas} 
          closeModalPendingCash={onHide}
        />
      </Modal.Body>
    </Modal>
  )
}

export default ModalPendingCash